// extracted by mini-css-extract-plugin
export default {"customConfirmDialog":"ConfirmDialog_customConfirmDialog__aeH8l"};